import React, { useRef } from 'react';
import { getTimestamp, now } from 'owa-datetime';
import { ListViewRsvpUnit } from 'mini-mail-list-rsvp-view';
import { ListViewRsvpUnitProps } from '../schema/ListViewRsvpUnit.types';

const ListViewRsvpUnitWrapper = (props: ListViewRsvpUnitProps) => {
    const listViewItemRenderTime = useRef<number>(getTimestamp(now()));

    return <ListViewRsvpUnit {...props} listViewItemRenderTime={listViewItemRenderTime} />;
};

export default ListViewRsvpUnitWrapper;
